var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappTemplateUtilityIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161014",
    "data-name": "Group 161014",
    transform: "translate(-268 -441)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2177",
    "data-name": "Rectangle 2177",
    width: 30,
    height: 30,
    rx: 4,
    transform: "translate(268 441)",
    fill: "#c9e7fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "web-app",
    transform: "translate(273.754 447.442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notice-active",
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M11.269,3.871a1.64,1.64,0,1,1,1.687,2.061,3.928,3.928,0,0,1,.225,1.315v3.935h.656a.656.656,0,0,1,0,1.312H11.213v.656a1.967,1.967,0,1,1-3.935,0v-.656H4.656a.656.656,0,0,1,0-1.312h.656V7.246A3.936,3.936,0,0,1,8.59,3.366v-.71a.656.656,0,0,1,1.312,0v.71A3.909,3.909,0,0,1,11.269,3.871ZM9.246,13.8a.656.656,0,0,0,.656-.656v-.656H8.59v.656A.656.656,0,0,0,9.246,13.8ZM6.623,11.181h5.246V7.246a2.623,2.623,0,0,0-5.246,0Z",
    transform: "translate(-4 -2)",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappTemplateUtilityIcon);
export default __webpack_public_path__ + "static/media/whatsapp-template-utility-icon.fcd30eaafddc5d44fe037b4311505816.svg";
export { ForwardRef as ReactComponent };